import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
// import { getDate } from "../../../utils/date";
import "./react-datepicker.less";
import "./style.less";

export default function InputDateRangePicker({
  onChangeDate = () => {},
  dateFormat = "MM/DD/YYYY",
  valueKey,
  selectedIds = [],
  selectedVal,
  isDefaultFilter,
  className= ""
}) {
  const [startDate, setStartDate] = useState((selectedIds?.length <= 0 || selectedIds.split("-")[0] === "" || selectedIds.split("-")[0] === null || selectedIds.split("-")[0] === "null") ? null : new Date(selectedIds.split("-")[0]));
  const [endDate, setEndDate] = useState((selectedIds?.length <= 0  || selectedIds.split("-")[1] === "" || selectedIds.split("-")[1] === null || selectedIds.split("-")[1] === "null") ? null : new Date(selectedIds.split("-")[1]));
  useEffect(() => {
    if (selectedIds?.length > 0) {
      setStartDate((selectedIds?.length <= 0 || selectedIds.split("-")[0] === "" || selectedIds.split("-")[0] === null || selectedIds.split("-")[0] === "null") ? null : new Date(selectedIds.split("-")[0]));
      setEndDate((selectedIds?.length <= 0 || selectedIds.split("-")[1] === "" || selectedIds.split("-")[1] === null || selectedIds.split("-")[1] === "null") ? null : new Date(selectedIds.split("-")[1]));
    } else if (selectedVal == undefined) {
      setStartDate();
      setEndDate();
    }
  }, [selectedIds]);

  useEffect(() => {
    selectDate();
  }, [startDate, endDate]);

  /** date selection function */
  function selectDate() {
    const value =  startDate && endDate
    ? `${moment(startDate).format(dateFormat)}-${moment(endDate).format(
        dateFormat
      )}`
    : isDefaultFilter === true && startDate 
    ? `${moment(startDate).format(dateFormat)}-${null}`
    : isDefaultFilter === true && endDate 
    ? `${null}-${moment(endDate).format(dateFormat)}`
    : "";
    onChangeDate(
      value,
      valueKey
    );
  }

  return (
    <div className={"date-range-picker"}>
      <DatePicker
        placeholderText={"From Date..."}
        selected={startDate}
        onChange={date => setStartDate(date)}
        selectsStart
        minDate={"1/1/1700"}
        startDate={startDate}
        endDate={endDate}
        value={startDate}
        onKeyDown={e => {
          e.preventDefault();
        }}
        isClearable
        className={className}
      />
      <DatePicker
        placeholderText={"To Date..."}
        selected={endDate}
        onChange={date => setEndDate(date)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        value={endDate}
        onKeyDown={e => {
          e.preventDefault();
        }}
        popperPlacement={"bottom-end"}
        isClearable
        className={className}
      />
    </div>
  );
}
